import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/auth/Login';
import Docks from './views/dock/Docks';
import PalletsLogs from './views/dock/PalletsLogs';
import PalletsStats from './views/dock/PalletsStats';
import ShippingOfflineLocations from './views/dock/ShippingOfflineLocations';
import LoadApprovalPins from './views/load_approval/LoadApprovalPins';
import LoadApprovalLogs from './views/load_approval/LoadApprovalLogs';
import Users from './views/auth/Users';
import store from './store';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      name: 'Root',
      component: Docks,
      beforeEnter: (to, from, next) => {
        if (store.state.auth.token) {
          store.dispatch('connection/setupConnection', { root: true });
          store.commit('navigation/setTabIndex', 0, { root: true });
          return next();
        }
        next('/login');
      }
    },
    {
      path: '/pallets-logs',
      name: 'PalletsLogs',
      component: PalletsLogs,
      beforeEnter: (to, from, next) => {
        if (store.state.auth.token) {
          store.dispatch('dock/fetchPalletsLogs', null, { root: true });
          store.commit('navigation/setTabIndex', 1, { root: true });
          return next();
        }
        next('/login');
      }
    },
    {
      path: '/pallets-stats',
      name: 'PalletsStats',
      component: PalletsStats,
      beforeEnter: (to, from, next) => {
        if (store.state.auth.token) {
          store.dispatch('dock/fetchPalletsStats', null, { root: true });
          store.commit('navigation/setTabIndex', 2, { root: true });
          return next();
        }
        next('/login');
      }
    },
    {
      path: '/shipping-offline-locations',
      name: 'ShippingOfflineLocations',
      component: ShippingOfflineLocations,
      beforeEnter: (to, from, next) => {
        if (store.state.auth.token) {
          if (store.getters['auth/isAdmin'] || store.getters['auth/isSupervisor']) {
            store.dispatch('shippingOfflineLocation/fetchShippingOfflineLocations', null, {
              root: true
            });
            store.commit('navigation/setTabIndex', 3, { root: true });
            return next();
          } else {
            return next({ name: 'Root' });
          }
        }
        next('/login');
      }
    },
    {
      path: '/load-approval-pins',
      name: 'LoadApprovalPins',
      component: LoadApprovalPins,
      beforeEnter: (to, from, next) => {
        if (store.state.auth.token) {
          if (store.getters['auth/isAdmin'] || store.getters['auth/isSupervisor']) {
            store.dispatch('loadApproval/fetchLoadApprovalPins', null, {
              root: true
            });
            store.commit('navigation/setTabIndex', 4, { root: true });
            return next();
          } else {
            return next({ name: 'Root' });
          }
        }
        next('/login');
      }
    },
    {
      path: '/load-approval-logs',
      name: 'LoadApprovalLogs',
      component: LoadApprovalLogs,
      beforeEnter: (to, from, next) => {
        if (store.state.auth.token) {
          if (store.getters['auth/isAdmin'] || store.getters['auth/isSupervisor']) {
            store.dispatch('loadApproval/fetchLoadApprovalLogs', null, {
              root: true
            });
            store.commit('navigation/setTabIndex', 5, { root: true });
            return next();
          } else {
            return next({ name: 'Root' });
          }
        }
        next('/login');
      }
    },
    {
      path: '/users',
      name: 'Users',
      component: Users,
      beforeEnter: (to, from, next) => {
        if (store.state.auth.token) {
          if (store.getters['auth/isAdmin']) {
            store.dispatch('user/fetchUsers', null, { root: true });
            store.commit('navigation/setTabIndex', 6, { root: true });
            return next();
          } else {
            return next({ name: 'Root' });
          }
        }
        next('/login');
      }
    },
    { path: '*', redirect: '/' }
  ]
});
